import { Register } from "../components/gw-register/Register";
import { SpaceBetween } from "@cloudscape-design/components-themed";
import { USER_TYPE, PERMISSIONS } from "../configs/constants";
import { useCanIShowHook } from "../app/useCanIShowHook";
import { useAuthenticationHook } from "../app/useAuthenticationHook";

/* 
GW事業者登録情報登録画面
 */
const GwBusinessInfoRegister = () => {
  //権限制御
  useAuthenticationHook(PERMISSIONS.GW);
  // 事業者種別取得
  const isDocomoUser = useCanIShowHook(USER_TYPE.DOCOMO);
  return <SpaceBetween size="l">{isDocomoUser && <Register />}</SpaceBetween>;
};

export default GwBusinessInfoRegister;
